// Assuming the html content is always sanitized HTML to disable the eslint warning
/* eslint-disable react/no-danger */
import React from 'react';

const SearchHighlightSegment = ({ htmlContent }) => (
  <p className="search-highlights" dangerouslySetInnerHTML={{ __html: htmlContent }} />
);

export default SearchHighlightSegment;
